import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { Hyperlink } from '../../components/Hyperlink';
import { withUser } from '../../user/UserContext';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { Connect, PropsFromRedux } from './FolderItemContainer';
import { Folder } from '../folders.types';
import { FoldersToastDecisionRemoved } from '../toast/FoldersToast';
import { CloseToasterButton } from '../../components/toaster/close/CloseToasterButton';
import { UserContextType } from '../../user/user.types';
import styles from './folder_item.module.scss';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';

type Props = PropsFromRedux & {
  docId: string;
  folder: Folder;
  source: string;
} & UserContextType;

export const RawFolderItem: FC<Props> = ({
  accessPremium,
  folder,
  source,
  onRemoveClicked,
}) => {
  const removeFromFolder = () => {
    onRemoveClicked();
    toast(
      <FoldersToastDecisionRemoved
        folderKey={folder.folderKey}
        title={folder.title}
      />,
      {
        autoClose: 7000,
        pauseOnHover: true,
        closeOnClick: false,
        closeButton: <CloseToasterButton />,
      },
    );
  };

  return (
    <>
      <Hyperlink
        className={`${styles.link} button primary`}
        {...(accessPremium
          ? {
              href: buildUrlWithParameters(`/dossiers/${folder.folderKey}`, {
                source,
              }),
            }
          : {})}
      >
        <MaterialIcon name="folder" />
        <span className={styles.label}>{folder.title}</span>
      </Hyperlink>
      {accessPremium && (
        <button
          type="button"
          className="button"
          onClick={removeFromFolder}
          name="remove-from-folder"
        >
          <MaterialIcon name="close" />
        </button>
      )}
    </>
  );
};

export const FolderItem = Connect(withUser(RawFolderItem));
